import { Seat, SeatZone, SeatPricing, CartSeat } from '../../classes/seat';
import { PriceType } from '../../classes/price-type';

import SeatPath from './seat-path';
import * as React from 'react';

interface IBackgroundPaths {
    paths: Array<string>;
    seatmapBackgroundPathFill: string;
    seatmapBackgroundPathStroke: number;
}

class BackgroundPaths extends React.PureComponent<IBackgroundPaths, any> {
    render() {
        return <g>
            {
                this.props.paths.map((path, index) => {
                    return <path key={index} d={path} fill={this.props.seatmapBackgroundPathFill}
                        strokeWidth={this.props.seatmapBackgroundPathStroke}
                        stroke={this.props.seatmapBackgroundPathFill} />
                })
            } </g>
    }
}

export default BackgroundPaths;